import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import LandingPage from "./Landing";
import NotFoundPage from "./components/NotFound";
import HomePage from "./HomePage";
import Thankyou from "./Thankyou";
import "./App.css";
import FeedbackPage from "./FeedbackPage";
const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/:client_key" element={<LandingPage />} />
        <Route path="/:client_key/feedback" element={<FeedbackPage />} />
        <Route path="/thankyou" element={<Thankyou />} />

        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
};

export default App;
